<template>
  <div id="app">
    <Header v-if="$route.path !== '/'" />
    <transition name="path">
      <router-view :key="$route.fullPath"/>
    </transition>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import Header from "@/components/Header.vue";

export default {
  name: 'App',
  components: {
    Header,
  },
  computed: {
    ...mapState({
      results: state => state.results
    })
  },

}
</script>


<style lang="scss">

@font-face {
    font-family: 'pdf';
    src: url('./assets/fonts/DIN-Pro.otf') format('opentype');
    font-weight: 400;
}

@font-face {
    font-family: 'DIN-Pro';
    src: url('./assets/fonts/DIN-Pro-Light.otf') format('opentype');
    font-weight: 200;
}

@font-face {
    font-family: 'DIN-Pro';
    src: url('./assets/fonts/DIN-Pro-Medium.otf') format('opentype');
    font-weight: 600;
}

@font-face {
    font-family: 'DIN-Pro';
    src: url('./assets/fonts/DIN-Pro-Cond-Black.otf') format('opentype');
    font-weight: 900;
}

@font-face {
    font-family: 'countach-bold';
    src: url('./assets/fonts/Countach-Bold.otf') format('opentype');
    font-weight: normal;
}

:root {
  --c-red: #CC0633;
  --c-red-secondary: #A6192E;
  --c-black: #414042;
  --c-light-grey: #F5F5F5;
  --c-link: #6D6F71;
  --font-countach: 'countach-bold';
  --font-pdf: 'DIN-Pro';
}

.link {
    color: var(--c-link);
}

.sr-only {
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}

body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'pdf';
}

 *,
*:before,
*:after {
  box-sizing: border-box;
}

p {
  margin: 0;
}

#app {
  font-family: 'pdf', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  overflow: hidden;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 768px) {
  .container {
    padding: 0 2rem;
  }
}

/* .path-enter-active, .path-leave-active {
  transition: all .5s ;
} */
/* .path-enter,
.path-leave-to {
  opacity: 1;
  transform: translateY(0px);
} */
/*
.path-leave,
.path-enter-to {
  opacity: 0;
  transform: translateY(10px);
} */
</style>
